import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { OverrideParameterStatusRequest } from '@/api/generated/HCA'
import { ComponentType } from '@/configuration/component/component-types'

export const useStatusAssessmentOverrideMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (overrideParametersStatus: OverrideParameterStatusRequest) =>
            hcaClientFactory.componentStatusApi.overrideParameterStatusById(overrideParametersStatus),
        onSuccess: async (response, payload) => {
            if (payload.overrideData?.componentType === ComponentType.Transformer) {
                await queryClient.invalidateQueries({ queryKey: ['transformers', payload.overrideData.componentSid] })
            } else if (payload.overrideData?.componentType === ComponentType.Generator) {
                await queryClient.invalidateQueries({ queryKey: ['generators', payload.overrideData.componentSid] })
            }
            await queryClient.invalidateQueries({ queryKey: ['comments', payload.overrideData?.componentSid] })
            await queryClient.invalidateQueries({ queryKey: ['componentStatus', payload.overrideData?.componentSid, payload.overrideData?.componentType] })
        },
    })
}
